import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Alert, Dialog } from '@mui/material';

import { useMst } from '../../models/rootModel';
import { sendGTMEvent } from '../../utils/googleTagManager';

import { BaseStep, StepProps, TitleAndDescriptionProps, StepWizardProps } from '../common/BaseStep';

export interface MockPaymentStepProps extends TitleAndDescriptionProps, StepProps, StepWizardProps {}

export const MockPaymentStep = observer((props: MockPaymentStepProps) => {
  const [alert, setAlert] = useState('');

  const { UserPayment, UserDiscoveryResponse } = useMst();
  const { isActive, nextStep } = props;

  useEffect(() => {
    if (isActive) {
      window.scrollTo(0, 0);
    }
  }, [isActive]);

  const mockPayment = () => {
    UserPayment.makeMockPayment()
      .then((res) => {
        if (!res) {
          throw new Error('No go! You shell not pass');
        }

        sendGTMEvent({
          event: 'purchase',
          ecommerce: {
            transaction_id: UserPayment.purchaseId,
            value: 0,
            currency: 'USD',
            tax: 0,
            coupon: 'NA', // Coupon code, if applied
            first_time_client: 'yes',
            transaction_method: 'fake',
            user_id: UserDiscoveryResponse.accountId,
            items: [
              {
                item_id: UserPayment.planId,
                item_name: 'Premium',
                item_brand: 'Circles',
                coupon: 'NA',
                currency: 'USD',
                discount: 0,
                price: 0,
                quantity: 1,
              },
            ],
          },
        });

        nextStep();
      })
      .catch((error) => {
        console.log(error);
        setAlert(error.message);
      });
  };

  return (
    <>
      {isActive ? (
        <BaseStep {...props} changeButtonFunction={mockPayment}>
          <Dialog open={alert.length > 0} onClose={() => setAlert('')}>
            <Alert severity="error">{alert}</Alert>
          </Dialog>
        </BaseStep>
      ) : (
        ''
      )}
    </>
  );
});
